const constant = {
  baseUrl: "https://api.bydautoindia.com/",
  imageUrl: "https://byd-assets.s3.us-east-2.amazonaws.com/production/",
};

export default constant;
